var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBokunIdExample = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "376px",
    height: "70px",
    viewBox: "0 0 376 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "illustration/Id-sketch Bokun") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "illustration/Id-sketch-Bokun",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#DEE2E6",
    fill: "#FAFAFA",
    x: 0.5,
    y: 0.5,
    width: 375,
    height: 69
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#34404E",
    cx: 338.324324,
    cy: 35,
    r: 18
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(331.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bell",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.29314746,6.09375 C3.29157971,4.97088631 3.73833676,3.89385839 4.53423042,3.10178604 C5.33012407,2.30971369 6.40928967,1.86814533 7.53213281,1.87503587 C9.85184004,1.8923625 11.7073189,3.82050762 11.7073189,6.14670996 L11.7073189,6.5625 C11.7073189,8.66107207 12.1463766,9.87884355 12.5330807,10.5444223 C12.6178698,10.6891761 12.6188268,10.8682086 12.5355902,11.0138606 C12.4523536,11.1595127 12.297618,11.2495706 12.1298602,11.25 L2.87013574,11.25 C2.70235784,11.2495683 2.54760781,11.1594879 2.46437916,11.0138081 C2.38115052,10.8681283 2.38213964,10.6890723 2.46697266,10.5443209 C2.85388359,9.87871992 3.29314453,8.66096543 3.29314453,6.5625 L3.29314746,6.09375 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.625,11.6785714 L5.625,12.1473214 C5.625,13.1828553 6.46446609,14.0223214 7.5,14.0223214 C8.53553391,14.0223214 9.375,13.1828553 9.375,12.1473214 L9.375,11.6785714",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 7.5,
    cy: 1.5,
    r: 1.5
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#34404E",
    cx: 290.162162,
    cy: 35,
    r: 18
  }), /*#__PURE__*/React.createElement("g", {
    id: "Question",
    transform: "translate(286.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 3,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.43242843,8 C6.47747614,6.39817221 8,4.94431387 8,3.63842499 C8,1.62897835 6.209139,0 4,0 C1.790861,0 0,1.62897835 0,3.63842499",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#34404E",
    cx: 242,
    cy: 35,
    r: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.122796,29.3424557 L240.148451,37.980202 C241.523577,42.0307746 242.814029,42.0307746 244.019809,37.980202 C245.225589,33.9296294 246.074679,31.0503807 246.567081,29.3424557",
    id: "Path-21",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    id: "(12345)-Visit-Finlan",
    fontFamily: "Avenir-Book, Avenir",
    fontSize: 16.4,
    fontWeight: "normal",
    fill: "#212529"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 62,
    y: 41
  }, "(12345) Visit Finland"))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBokunIdExample);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bokun-id-example.6e35535e05136ac00de96fdcdc8250c8.svg";